import { ChangePasswordFormFieldsProps } from './types';

export const ChangePasswordFormFields = ({ children, classNames, ...props }: ChangePasswordFormFieldsProps) => {
    const { onSubmit } = props;
    return (
        <form className={`${classNames}`} onSubmit={onSubmit} {...props}>
            {children}
        </form>
    );
};
